import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SystemInformationState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: SystemInformationState = {
  data: [],
  isLoading: false,
  error: null,
};

const systemInformationSlice = createSlice({
  name: 'systemInformations',
  initialState,
  reducers: {
    setSystemInformations: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setSystemInformationLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSystemInformationError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setSystemInformations, setSystemInformationLoading, setSystemInformationError } =
  systemInformationSlice.actions;

export default systemInformationSlice.reducer;
